// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var DomainVerificationStatus_Enum;
(function (DomainVerificationStatus_Enum) {
    DomainVerificationStatus_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    DomainVerificationStatus_Enum["VERIFIED"] = "VERIFIED";
    DomainVerificationStatus_Enum["PENDING"] = "PENDING";
    DomainVerificationStatus_Enum["FAILED"] = "FAILED";
})(DomainVerificationStatus_Enum || (DomainVerificationStatus_Enum = {}));
export var DomainVerificationStatus_Enum_index;
(function (DomainVerificationStatus_Enum_index) {
    DomainVerificationStatus_Enum_index[DomainVerificationStatus_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    DomainVerificationStatus_Enum_index[DomainVerificationStatus_Enum_index["VERIFIED"] = 1] = "VERIFIED";
    DomainVerificationStatus_Enum_index[DomainVerificationStatus_Enum_index["PENDING"] = 2] = "PENDING";
    DomainVerificationStatus_Enum_index[DomainVerificationStatus_Enum_index["FAILED"] = 3] = "FAILED";
})(DomainVerificationStatus_Enum_index || (DomainVerificationStatus_Enum_index = {}));
export const EmailRecordsService = {
    /**
     * GetOutcomes returns stats on a filtered set of emails.
     * Use to determine if your emails are being opened, clicked, unsubscribed, etc.
     * This endpoint uses POST instead of GET because it allows an optional request body for filtering, which cannot be included in a standard GET request per grpc-gateway.
     */
    GetOutcomes(fn, req) {
        return fn(`/email/records/v1/outcomes`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * CreateDomain stores domain records created through an email provider (e.g. SendGrid).
     */
    CreateDomain(fn, req) {
        return fn(`/email/records/v1/domain`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * UpdateDomain updates the Domain record with the verification status
     * of domain ownership and the validity of the DNS records. This should
     * be called only after requesting DNS validation from the email provider.
     * Note: other domain record attributes are not updatable.
     */
    UpdateDomain(fn, req) {
        try {
            fm.validateUrlParam(req["domainId"], "domainId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/records/v1/domain/${req["domainId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetDomain retrieves a domain record. Soft-deleted domains are not returned.
     */
    GetDomain(fn, req) {
        try {
            fm.validateUrlParam(req["domainId"], "domainId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/records/v1/domain/${req["domainId"]}?${fm.renderURLSearchParams(req, ["domainId"])}`, { method: "GET" });
    },
    /**
     * DeleteDomain soft deletes a domain record from the domain table by
     * setting the deleted_at timestamp.
     */
    DeleteDomain(fn, req) {
        try {
            fm.validateUrlParam(req["domainId"], "domainId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/records/v1/domain/${req["domainId"]}?${fm.renderURLSearchParams(req, ["domainId"])}`, { method: "DELETE" });
    },
    /**
     * GetDomainsByOrgID retrieves all domain records associated with an organization.
     * Soft-deleted domains are not returned. An empty list is returned if no domains are found.
     */
    GetDomainsByOrgID(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/records/v1/organizations/${req["orgId"]}/domains?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    /**
     * UpsertLocationPersonalization creates or updates email personalization
     * settings for a location.
     */
    UpsertLocationPersonalization(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/records/v1/location_preference/${req["locationId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetLocationPersonalization retrieves email personalization settings for a location.
     */
    GetLocationPersonalization(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/email/records/v1/location_preference/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
};
